import { render } from "./trajectory.vue?vue&type=template&id=483ac0ae&scoped=true"
import script from "./trajectory.vue?vue&type=script&lang=js"
export * from "./trajectory.vue?vue&type=script&lang=js"

import "./trajectory.vue?vue&type=style&index=0&id=483ac0ae&lang=scss&scoped=true"

import exportComponent from "C:\\xiangmu\\gas-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-483ac0ae"]])

export default __exports__